<template>
  <div class="bg-black h-full w-full absolute bg-opacity-25 flex justify-center items-center">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'BaseModal',
  };
</script>
